import { render, staticRenderFns } from "./MultiStoreSettings.vue?vue&type=template&id=58d23a84"
import script from "./MultiStoreSettings.vue?vue&type=script&lang=ts"
export * from "./MultiStoreSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports